import React, { useRef, useEffect } from 'react';
import Metatags from '../metatags/metatags';
import CloseMenu from '../svg/close-menu';
import './modal-with-iframe.scss';

const ModalWithIframe = ({ videoUrl, visible, closeModal, metatags }) => {
  const iframeRef = useRef();

  const manageModalOnClose = event => {
    if (event instanceof KeyboardEvent && event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    closeModal();
    iframeRef.current.src = videoUrl;
  };

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [visible]);

  return visible ? (
    <>
      <Metatags isModal content={metatags} />
      <div className={`modal modal--with-iframe${visible ? ' modal--visible' : ''}`}>
        <div className='modal-content'>
          <button
            aria-label='Close'
            type='button'
            className='button button--icon modal-close'
            onClick={e => manageModalOnClose(e)}
          >
            <CloseMenu />
          </button>
          <iframe
            width='100%'
            height='500'
            src={videoUrl}
            title='Sherpa'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
            ref={iframeRef}
          />
        </div>
      </div>
      <div
        className={`modal-backdrop${visible ? ' modal-backdrop--visible' : ''}`}
        role='button'
        aria-label='Close'
        tabIndex={0}
        onClick={e => manageModalOnClose(e)}
        onKeyDown={e => manageModalOnClose(e)}
      />
    </>
  ) : null;
};

export default ModalWithIframe;
